import { useState, useEffect } from "react";
import { db } from "./../firebase/firebaseConfig";
//dates-fns
import { startOfMonth, endOfMonth, getUnixTime } from "date-fns";
import { useAuth } from "./../contextos/AuthContext";

const useObtenerGastosDelMes = () => {
  const [gastos, establecerGastos] = useState([]);
  const { usuario } = useAuth();

  useEffect(() => {
    const inicioDeMes = getUnixTime(startOfMonth(new Date()));
    const finDeMes = getUnixTime(endOfMonth(new Date()));
    //console.log(inicioDeMes, finDeMes)

    if (usuario) {
      const unsuscribe = db.collection("gastos")
        .orderBy("fecha", "desc")
        .where("fecha", ">=", inicioDeMes)
        .where("fecha", "<=", finDeMes)
        .where('uidUsuario', '==', usuario.uid)
        .onSnapshot(snapshot => {
          //console.log(snapshot.docs);
          establecerGastos(snapshot.docs.map(documento => {
            //console.log(documento.data());
            return {...documento.data(), id: documento.id}
          }));
        });
        //cierra la conexion
        return unsuscribe;
    }
  }, [usuario]);

  return gastos;
};

export default useObtenerGastosDelMes;
